import React, { useState, useRef, useEffect } from 'react';
import 'prop-types';
import { AnimatePresence, LazyMotion, domAnimation, m } from 'framer-motion';
import easingFunctions from '../../../utils/easingFunctions.js';

// Wrap index if it goes outside of bounds
const wrap = (min, max, v) => {
  const rangeSize = max - min;
  return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};
const variants = {
  enter: ({
    direction,
    travel
  }) => {
    return {
      x: direction > 0 ? travel : -travel,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: ({
    direction,
    travel
  }) => {
    return {
      zIndex: 0,
      x: direction < 0 ? travel : -travel,
      opacity: 0
    };
  }
};
const PanelSteps = ({
  children,
  step,
  className,
  duration,
  travel,
  ease,
  onStart,
  onComplete
}) => {
  const [[page, direction], setPage] = useState([step || 0, 0]);
  const containerRef = useRef(null);
  const itemIndex = wrap(0, children.length, page);
  const easingSettings = {
    type: easingFunctions[ease] || ease,
    duration
  };
  const variantProps = {
    travel,
    direction
  };
  const animationComplete = () => {
    containerRef.current.style.minHeight = 'auto';
    if (typeof onComplete === 'function') {
      onComplete();
    }
  };
  const onAnimationStart = () => {
    containerRef.current.style.minHeight = 'auto';
    containerRef.current.style.minHeight = `${containerRef.current.scrollHeight}px`;
    if (typeof onStart === 'function') {
      onStart();
    }
  };
  useEffect(() => {
    if (step !== page) {
      goTo(step);
    }
  }, [step]);
  const goTo = index => {
    setPage([index, index > page ? 1 : -1]);
  };
  if (!step && step !== 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: containerRef
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false,
    mode: "wait",
    custom: variantProps
  }, /*#__PURE__*/React.createElement(LazyMotion, {
    features: domAnimation,
    key: page
  }, /*#__PURE__*/React.createElement(m.div, {
    onAnimationComplete: animationComplete,
    onAnimationStart: onAnimationStart,
    custom: variantProps,
    variants: variants,
    initial: "enter",
    animate: "center",
    exit: "exit",
    transition: {
      easingSettings
    }
  }, children[itemIndex])))));
};
PanelSteps.defaultProps = {
  color: 'primary',
  size: 'md',
  align: '',
  timeout: 300,
  axis: 'X',
  travel: 300,
  duration: 0.5,
  step: 0,
  ease: 'easeInOutCubic'
};

export { PanelSteps as default };
